/*
  Keeps the price in the Add to Cart button (the product section's "Price in
  Add to Cart button" setting, snippets/buy-buttons.liquid) in step with the
  offer: the chosen volume tier's price (our ladder, nr-offer-ladder.js, or
  Appstle's widget), or else the price block, as either changes. Without
  either, the price Liquid wrote stays.
*/
(() => {
  const read = (box) => {
    const tier = box.querySelector(
      ":is(.ab-volume-discount-item-selected, [class*='-selected-discount-']) .volume-discount-price, .nr-ladder__tier.is-selected .nr-ladder__price"
    );
    if (tier) return tier.textContent.trim();
    const price = box.querySelector('.price');
    if (!price) return null;
    const item = price.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--last')
      : price.querySelector('.price__regular .price-item--regular');
    return item ? item.textContent.trim() : null;
  };

  document.querySelectorAll('[data-nr-button-price]').forEach((label) => {
    const box = label.closest('.product__info-container');
    if (!box || label.dataset.nrWatched) return;
    label.dataset.nrWatched = 'true';
    const update = () => {
      // Dawn may swap the button for a fresh copy when the variant changes.
      const current = box.querySelector('[data-nr-button-price]');
      const price = read(box);
      if (current && price && current.textContent !== price) current.textContent = price;
    };
    update();
    new MutationObserver(update).observe(box, { childList: true, subtree: true, characterData: true });
    // Our ladder only moves a class when a tier is picked, so it says so.
    box.addEventListener('nr:offer-change', update);
  });
})();
